var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnisatWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000053523035133676211620000008657505104723346622_);}\r\n\t.st2{fill:url(#SVGID_00000080885488505437130520000011478164162494726811_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4,29.7H3.6c-1.8,0-3.3-1.5-3.3-3.3V3.6c0-1.8,1.5-3.3,3.3-3.3h22.8c1.8,0,3.3,1.5,3.3,3.3v22.8 C29.7,28.2,28.2,29.7,26.4,29.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.0539,
    y1: 12.9177,
    x2: 23.333,
    y2: 10.0473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7D71A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    style: {
      stopColor: "#EF8E1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#FF771A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8324,
    style: {
      stopColor: "#1E110E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,19.8c-0.4,0-0.8-0.1-1.1-0.4l-6.1-6.2c-0.3-0.3-0.5-0.7-0.6-1c-0.3-1-0.7-3.5,1.9-6.1 c2.3-2.3,4.4-2.6,5.5-2.5c0.6,0,1.2,0.3,1.7,0.7l7,6.4c0.6,0.6,0.7,1.5,0.1,2.1c-0.6,0.6-1.5,0.7-2.1,0.1L15,7.3 c-0.7-0.6-1.6-0.7-2.4-0.3c-0.5,0.2-1,0.6-1.6,1.2C10.5,8.6,10.2,9,10,9.4c-0.4,0.8-0.2,1.8,0.4,2.4c1.3,1.3,4.1,4.1,5.3,5.4 c0.6,0.6,0.7,1.5,0.2,2.1C15.6,19.6,15.2,19.8,14.8,19.8z M14.3,6.5C14.3,6.5,14.3,6.5,14.3,6.5C14.3,6.5,14.3,6.5,14.3,6.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100352479461397400370000010704208464321973436_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.4355,
    y1: 35.2299,
    x2: 111.7145,
    y2: 32.3595,
    gradientTransform: "matrix(-1 0 0 -1 118.5827 53.453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7D71A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    style: {
      stopColor: "#EF8E1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#FF771A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8324,
    style: {
      stopColor: "#1E110E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100352479461397400370000010704208464321973436_)"
    },
    d: "M17.2,12.2c0.4,0,0.8,0.1,1.1,0.4l4.1,4.2 c0.3,0.3,0.5,0.7,0.6,1c0.3,1,0.7,3.5-1.9,6.1c-2.3,2.3-4.4,2.6-5.5,2.5c-0.6,0-1.2-0.3-1.7-0.7l-7-6.4c-0.6-0.6-0.7-1.5-0.1-2.1 c0.6-0.6,1.5-0.7,2.1-0.1l6.1,5.5c0.6,0.6,1.6,0.7,2.3,0.3c0.5-0.2,1.1-0.6,1.7-1.2c0.5-0.5,0.8-0.9,1-1.3c0.4-0.8,0.2-1.7-0.4-2.3 l-3.4-3.5c-0.6-0.6-0.6-1.5,0-2.1C16.5,12.3,16.9,12.2,17.2,12.2z M15.7,23.5C15.7,23.5,15.7,23.5,15.7,23.5 C15.7,23.5,15.7,23.5,15.7,23.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013882567696928354010000001783152588170263705_",
    cx: 5.6009,
    cy: 10.9185,
    r: 2.2298,
    gradientTransform: "matrix(0.7718 0 0 0.7718 9.7892 2.4607)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7D71A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    style: {
      stopColor: "#EF8E1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E110E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000013882567696928354010000001783152588170263705_)"
    },
    cx: 14.1,
    cy: 10.9,
    r: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisatWallet);
export default __webpack_public_path__ + "static/media/unisat-wallet.cfb5b84ace06f5c140f62f24e62b6d6a.svg";
export { ForwardRef as ReactComponent };